// 获取注册内容弹窗组件
export function getRegisterDialogData() {
    return [

        {
            key: "school",
            name: "毕业院校",
            value: '',
            type: 'input',
            isNull: false, prompt: "(注:需填写学校全称)", writeOrRead: 'write'

        }, {
            key: "profession",
            name: "毕业专业",
            value: '',
            type: 'input',
            isNull: false, prompt: "(注:需填写专业全称)", writeOrRead: 'write'

        }, {
            key: "idCard",
            name: "身份证号",
            value: '',
            type: 'input',
            isNull: false, writeOrRead: 'write'

        }, {
            key: "password",
            name: "密码",
            value: '',
            type: 'input_password',
            isNull: false, writeOrRead: 'write'

        },
        {
            key: "makesurepassword",
            name: "确认密码",
            value: '',
            type: 'input_password2',
            isNull: false, writeOrRead: 'write'

        },
        {
            key: "phone",
            name: "手机号",
            value: '',
            type: 'input_phone',
            isNull: false, writeOrRead: 'write'

        },
        //  {
        //     key: "code",
        //     name: "验证码",
        //     value: '',
        //     type: 'input-yzm',
        //     isNull: false, writeOrRead: 'write'

        // },

    ]
}